const mul_cities = [
    {
        cityName: "Bengaluru",
        cityDate: "27th August, 2023",
        cityVenue: "Dayanand Sagar College of Engineering",
        cityColor: "green",
    },
    {
        cityName: "Jaipur",
        cityDate: "10th September, 2023",
        cityVenue: "Swami Keshvanand Institue of Technology",
        cityColor: "pink",
    },
    {
        cityName: "Delhi",
        cityDate: "4th - 5th November, 2023",
        cityVenue: "TBA",
        cityColor: "indigo",
    },
    {
        cityName: "Pune",
        cityDate: "28th October, 2023",
        cityVenue: "TBA",
        cityColor: "orange",
    },
    {
        cityName: "Mumbai",
        cityDate: "2nd December, 2023",
        cityVenue: "TBA",
        cityColor: "yellow",
    },
    {
        cityName: "Rishikesh",
        cityDate: "7th - 11th Sept, 2023",
        cityVenue: "Pyrexia, AIIMS Rishikesh",
        cityColor: "green",
    },
    {
        cityName: "Vellore",
        cityDate: "11th - 16th Sept, 2023",
        cityVenue: "Pegasus, Christian Medical College Vellore",
        cityColor: "indigo",
    },
    {
        cityName: "Baroda",
        cityDate: "30th Sept - 2nd Oct, 2023",
        cityVenue: "Paramarsh, MSU Baroda",
        cityColor: "pink",
    },
    {
        cityName: "Allahabad",
        cityDate: "18th - 21st Oct, 2023",
        cityVenue: "Effervesence, IIIT Allahabad",
        cityColor: "orange",
    },
    {
        cityName: "Nagpur",
        cityDate: "27th - 29th Oct, 2023",
        cityVenue: "Aarohi, VNIT Nagpur",
        cityColor: "yellow",
    },
    {
        cityName: "Indore",
        cityDate: "27th - 29th Sept, 2023",
        cityVenue: "Atharv Ranbhoomi, IIM Indore",
        cityColor: "green",
    },
    {
        cityName: "Raipur",
        cityDate: "2nd - 5th Nov, 2023",
        cityVenue: "Oriana, AIIMS Raipur",
        cityColor: "indigo",
    },
    {
        cityName: "Chandigarh",
        cityDate: "3rd - 5th Nov, 2023",
        cityVenue: "PECFEST, Punjab Engineering College",
        cityColor: "pink",
    },
    {
        cityName: "Gwalior",
        cityDate: "5th - 7th Nov, 2023",
        cityVenue:
            "Spandan, Prestige Institute of Management & Research Gwalior",
        cityColor: "orange",
    },
    {
        cityName: "Kolkata",
        cityDate: "18th - 20th Nov, 2023",
        cityVenue: "7 lakes fest, IIM Calcutta",
        cityColor: "yellow",
    },
    {
        cityName: "Bhagalpur",
        cityDate: "3rd - 5th Nov, 2023",
        cityVenue: "Enyugma, IIIT Bhagalpur",
        cityColor: "indigo",
    },
];

export default mul_cities;
